import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson6: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson5"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">Bitcoin Intro</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson7"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>

        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[10.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-white font-dm-sans">

        <div className="self-stretch flex flex-row items-center justify-center gap-[3.63rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>What Is Blockchain</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              The Blockchain is an immutable, decentralised digital ledger that
              records all transactions across a peer to peer network.
            </p>
            <p className="m-0">
              The Blockchain is a data storage system that automatically records
              all transactions across a network. A transaction can be financial
              or the transfer of an asset. It's simply the dealings of two
              parties.
            </p>
            <p className="m-0">
              This network consists of hundreds of thousands of nodes
              (computers) worldwide that are constantly processing transactions
              in sync with one another. Therefore the network is decentralised
              and the power doesn't sit with one authority such as a centralised
              bank.
            </p>
          </div>
          <img
            className="relative w-[38.56rem] h-[24.13rem] object-cover"
            alt=""
            src="/i28@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            That might sound illogical at first, but as all data is encrypted
            using cryptography and the transactions are uneditable (immutable),
            your data is completely safe. If one node somehow has different data
            to the other nodes then it is ignored.
          </p>
          <p className="m-0">
            In recent years, the blockchain analysis industry has grown
            significantly, with the United States Government spending $6 million
            on such activities. This has also led to the rise of blockchain
            analysis firms, which have collectively raised $80 million. To
            understand this trend, it is important to first understand what
            blockchain analysis is.
          </p>
          <p className="m-0">
            Blockchain technology is the underlying technology behind digital
            currency transactions. It is used to build a decentralized ledger
            that verifies and records transactions. However, like any financial
            exchange, cryptocurrency transactions can also be targeted by
            fraudulent activities. This is where blockchain analysis comes in,
            as it can detect any suspicious or illegal activity by tracking
            blockchain data in real time.
          </p>
          <p className="m-0">
            While it is not mandatory for crypto exchanges to hire blockchain
            analysts, many do so to prevent criminal activities such as money
            laundering and fraud. These analysis firms also provide benefits
            such as revenue forecasting, customer intelligence reports, and new
            service development. They are often referred to as blockchain
            forensics businesses.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.63rem] text-[1.88rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-white">
              <b>What Are The Benefits of Blockchain?</b>
            </p>
            <p className="m-0 text-[1.56rem]">&nbsp;</p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  No middlemen/intermediaries. Using blockchain, two parties in
                  a transaction can confirm and complete something without
                  working through a third party. This saves time as well as the
                  cost of paying for an intermediary like a bank.
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  Extra Security. Due to the decentralisation of the Blockchain
                  network it is almost impossible for someone to make fraudulent
                  transactions. To input forged transactions, the bad actor
                  would need to hack every node and change every ledger which is
                  far less likely than a bank being hacked.
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[38.63rem] h-[24.13rem] object-cover"
            alt=""
            src="/i29@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li>
              Improved Speed. Since blockchains operate 24/7, people can make
              more efficient financial and asset transfers, especially
              internationally. They don’t need to wait potentially days for a
              bank to confirm everything.
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>
                From Satoshi to Today: A Journey Through Blockchain Analysis
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The history of blockchain fraud and attacks is the origin of the
                history of blockchain analysis. The first serious case of
                fraudulent activity involving bitcoins was reported in 2011.
                This was the year that a Bitcoin user suffered a loss of
                $500,000 due to fraudulent activity. During the course of that
                same year, an electronic wallet service provider known as
                MyBitcoins disappeared from the internet. These occurrences
                continued to occur throughout the year 2012, culminating in the
                hacking and subsequent closure of multiple exchanges.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another cryptocurrency exchange, known as BitStamp, was
                compromised in the year 2015. In 2016, criminals hacked into the
                Bitfinex exchange and made off with a staggering 77 million
                dollars. As the number of incidents of this kind increased, a
                growing number of companies that specialized in blockchain
                research and blockchain forensics began to crop up. The reality
                that there was an increasing need for such services was made
                obvious by the rising number of hacks that occurred. Between the
                years 2013 and 2017, a number of companies specializing in
                blockchain analysis or blockchain forensics were founded. Many
                of them are currently functioning as top-tier enterprises in
                their respective industries.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>{`Transparency & Traceability: The Benefits of Blockchain Analysis`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Blockchain technology, cryptocurrency exchanges, crypto wallets,
                and exchange transactions are all susceptible to hacks and
                attacks, creating a high-risk environment that necessitates
                protective measures. This is where blockchain analysis and
                forensics become essential. Let's delve into the details of this
                critical role. Fund tracing and transaction analysis are the
                fundamental tasks of blockchain analysis. These forensic
                companies continuously scrutinize every transaction on any
                blockchain protocol and frequently monitor the addresses
                involved, categorizing and grouping them accordingly. If any
                suspicious activity occurs through these addresses, an alert is
                issued.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                At a more in-depth level, blockchain analysis provides
                transparency in the flow of funds. It is a challenging task to
                comprehend the inflow and outflow of crypto funds, particularly
                when transactions involve thousands of addresses. By cutting
                through the clutter and extracting the most significant
                information, blockchain analysis assists in identifying and
                categorizing transaction behaviours, allowing immediate
                follow-up of any suspicious activities. This aids in identifying
                the root of any illicit acts.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Blockchain analysis companies also validate information on
                behalf of their clients, performing necessary checks on
                potential partner claims. By preparing transaction profiles of
                selected addresses, blockchain analysis proves beneficial.
                Finally, these companies are essential in monitoring
                stablecoins, tracking secondary market transactions, and
                documenting audit trails and decision paths. Overall, blockchain
                analysis provides a clear visualization of the entire blockchain
                transaction scene, offering transparency and traceability in the
                movement of funds.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>{`Challenges & Strategies For Effective Blockchain Analysis`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Even though blockchain analysis and blockchain forensics play a
                crucial role in securing the cryptocurrency ecosystem, they face
                several challenges. Experienced crypto holders are adept at
                using tricks and strategies to outsmart these analysis firms.
                Let's take a closer look at some of these obstacles.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One common technique used to evade traceability is the use of
                mixers. Mixers combine the inputs of multiple senders and
                conceal their unique addresses. The mixed input is then sent
                from a single address, making it virtually impossible to trace
                the original addresses.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another popular anonymity method is creating multiple wallets
                and conducting multiple transactions between them. This makes
                the address increasingly difficult to track back to its owner.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                People also tend to use exchanges that don't comply with Know
                Your Customer (KYC) regulations. They also resort to
                non-custodial coin exchangers to bypass blockchain analysis.
                Similarly, privacy-conscious wallets are used to avoid detection
                by blockchain forensics. All of these techniques pose
                significant challenges for blockchain analysis companies.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>The Future of Blockchain Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The use of untraceable addresses for money laundering in
                unregulated and risky crypto trading is a common threat.
                Non-compliance with KYC requirements puts stakeholders at risk,
                so monitoring of all transactions and addresses is necessary
                with alerts as needed. Industry-wise data analysis helps assess
                business profiles and activity patterns. Blockchain analysis is
                a necessary tool for exchanges to protect against hacks, choose
                partners, and detect fraud. It also provides measures to track,
                trace, and improve the environment by collecting intelligence.
                As the blockchain technology advances and crypto exchanges
                expand, blockchain analysis will become even more important.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The future of blockchain analysis looks promising as the
                technology continues to evolve and more businesses adopt it.
                Artificial intelligence and machine learning will also enhance
                the capabilities of blockchain analysis, making it easier to
                detect fraudulent activities and prevent hacks. Additionally,
                the rise of decentralized finance (DeFi) will create new
                challenges for blockchain analysis, but also opportunities to
                innovate and develop new tools and techniques. Overall, the
                future of blockchain analysis is bright, and it will continue to
                play a vital role in shaping the future of the crypto industry.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Blockchain is a peer to peer ledger system that allows peers to
                transact between them without any centralized authority
                (government/bank).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To help you better understand what blockchain is, let’s first
                look at how a web application (Gmail, Facebook, etc) works.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Usually, we use a browser to access a web application. That
                browser connects to a central server over a network. These
                servers host (store) all of the code for that web application,
                and all of the data is stored inside a database. It is all
                "centralized" to that database owned by the company.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>
                What is the Problem With a Traditional Web App System?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  We can’t effectively store value - For example, it's not
                  possible to create digital money with a traditional web
                  application.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>&nbsp;</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Code Manipulation - The code could be changed by the
                  application developers at their discretion. As long as they
                  have access to the database they are able to manipulate the
                  code. This means with that access they can control the money
                  and steal your funds or change your balance.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>&nbsp;</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Centralization - This means the power is held by one
                  organisation. Instead, we want to use the blockchain. With its
                  technology, we can rest assured that our money works in a
                  predictable way, and that our funds can’t be stolen, this is
                  because the blockchain is decentralized (Power is amongst
                  thousands of autonomous computers, explained below) and
                  irreversible.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>How Does The Blockchain Work?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Another way people often describe the blockchain is that it’s
                  a ledger (sometimes you’ll hear the terms ‘distributed ledger’
                  or ‘immutable ledger’), that is similar to the balance sheet
                  of a bank. Like a bank’s ledger, the blockchain tracks all the
                  money flowing into, out of, and through the network.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  But unlike a bank’s books, a crypto blockchain isn’t
                  maintained by any individual or organization, including banks
                  and governments. In fact it isn’t centralized at all. Instead,
                  it is secured by a large peer-to-peer network of computers
                  running open-source software. The network is constantly
                  checking and securing the accuracy of the blockchain.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Where does new cryptocurrency come from? Every so often –
                  around every ten minutes in the case of Bitcoin – a new chunk
                  of transaction information (or a new block) is added to the
                  chain of existing information. In exchange for contributing
                  their computing power to maintaining the blockchain, the
                  network rewards participants with a small amount of digital
                  currency.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  A crypto blockchain is distributed across the digital
                  currency’s entire network. No company, country, or third party
                  is in control of it; and anyone can participate..
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>{`How Do You Send & Receive Money Over A Blockchain?`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  The cryptocurrency network assigns each user a unique
                  ‘address,’ which is made up of a private key and a public key.
                  Anyone can send you money via your public key, which is akin
                  to an email address. When you want to spend your money, you
                  use your private key, which is basically your password, to
                  digitally ‘sign’ transactions. The easiest way to manage your
                  cryptocurrency is via software called a wallet, which you can
                  get via an exchange like Coinbase
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>.</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A blockchain a distributed database that is shared among the
                  nodes of a computer network. As a database, a blockchain
                  stores information electronically in digital format. To better
                  understand think of it basically as a huge world-wide computer
                  network.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Instead of using one single computer that stores data and runs
                  programs, blockchains use thousands of computers to handle
                  this. Each computer is called a “node”, and they all relay
                  information to one another.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Who Invented The Blockchain?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A person or group using the name Satoshi Nakamoto published a
                  whitepaper online explaining the principles behind a new kind
                  of digital money called Bitcoin in late 2008. Every
                  cryptocurrency since is an evolution of the ideas laid out in
                  that paper.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Nakamoto’s goal was to create digital money that would make
                  online transactions between two strangers anywhere in the
                  world possible without requiring a third party like a credit
                  card company or a payment processor like Paypal in the middle.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  This required a system that would eliminate a thorny issue
                  called the ‘double spending’ problem, where a person might use
                  the same money more than once. The solution is a network that
                  is constantly verifying the movement of Bitcoin. That network
                  is the blockchain.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Every Bitcoin transaction is stored and verified by a global
                  network of computers beyond the control of any person,
                  company, or country.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  The database that holds all of that information is called the
                  blockchain. Bitcoins are ‘mined’ via that huge, decentralized
                  (also known as peer-to-peer) network of computers, which are
                  also constantly verifying and securing the accuracy of the
                  blockchain. In exchange for contributing their computing power
                  to the blockchain, miners are rewarded with small amounts of
                  cryptocurrency.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Every single bitcoin transaction is reflected on the ledger,
                  with new information periodically gathered together in a
                  “block,” which is added to all the blocks that came before.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  The miners’ collective computing power is used to ensure the
                  accuracy of the ever-growing ledger. Bitcoin can’t exist
                  separately from the blockchain; each new bitcoin is recorded
                  on it, as is each subsequent transaction with all existing
                  coins.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Future Of Blockchains?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  The blockchain idea has turned out to be a platform that a
                  huge range of applications can be built on top of. It’s still
                  a new and rapidly developing technology, but many experts have
                  described blockchain’s potential to change the way we live and
                  work as being similar to the potential public internet
                  protocols like HTML had in the early days of the World Wide
                  Web.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  The Bitcoin Cash and Litecoin blockchains work in a very
                  similar way to the original Bitcoin blockchain. The Ethereum
                  blockchain is a further evolution of the distributed ledger
                  idea, because unlike the Bitcoin blockchain it’s not solely
                  designed to manage a digital money. (That said Ethereum is a
                  cryptocurrency and certainly can be used to send value to
                  another person). Think of the Ethereum blockchain more like a
                  powerful and highly flexible computing platform that allows
                  coders to easily build all kinds of applications leveraging
                  the blockchain.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  For example, imagine a charity that wants to send money to a
                  thousand people every day for a year. With Ethereum, that
                  would only take a few lines of code. Or maybe you’re a video
                  game developer that wants to create items like swords and
                  armor that can be traded outside of the game itself? Ethereum
                  is designed to do that, too.
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson7">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson6;
